import API from '../..';
const ENTITY = 'proposals';

export const bulkProposals = (data) =>
    API.put(`/api/v1/${ENTITY}/bulk-status-flags/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const createProposal = (data) => API.post(`/api/v1/${ENTITY}/`, data);
export const downloadProposalXls = (id) =>
    API.get(`/api/v1/${ENTITY}/export/${id}/`, { responseType: 'blob' });
export const enableEditionProposal = (id) =>
    API.put(`/api/v1/${ENTITY}/enable-edit/${id}/`);
export const filterProposals = ({ projectId = null, status = 'active' } = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: { project: projectId, status_flag: status },
    });
export const generateProposalReport = (data) =>
    API.post(`/api/v1/${ENTITY}/generate-preview/`, data);
export const getProposal = (proposalId) =>
    API.get(`/api/v1/${ENTITY}/${proposalId}/`);
export const duplicateProposal = (data, id) =>
    API.put(`/api/v1/${ENTITY}/clone/${id}/`, data);
export const partialUpdateProposal = (data, id) =>
    API.patch(`/api/v1/${ENTITY}/${id}/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const updateProposal = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
export const updateProposalContent = (id, data) =>
    API.patch(`/api/v1/${ENTITY}/${id}/`, data);
